import {
  useReduceWithModel,
  IModel,
} from '@/hooks/useReduceWithModel/useReduceWithModel';
import { IFetchHousekeeper } from '@/services/productTypes';

interface IState {
  projectCode: string;
  projectName: string;
  userId: string;
  isHouserKeeper: boolean;
  phone: string;
  projectList: IFetchHousekeeper['result']['projectList'];
}

const initialState: IState = {
  projectCode: '',
  projectName: '',
  userId: '',
  isHouserKeeper: false,
  phone: '',
  projectList: [],
};

/**
 * 可以直接返回state，也可以修改draft里面的数据，返回空
 * @param draft
 * @param action
 */

enum actionEnum {
  initalial = 'initalial',
  reset = 'reset',
  telPhone = 'telPhone',
}
const model: IModel<IState> = {
  immer: true,
  state: initialState,
  reducers: {
    [actionEnum.initalial](
      state: IState,
      action: { type: actionEnum; [extraProps: string]: any },
    ) {
      return {
        ...state,
        userId: action.payload.userId,
        projectCode: action.payload.bindProjectCode,
        projectName: action.payload.bindProjectName,
        isHouserKeeper: action.payload.isHouserKeeper,
        projectList: action.payload.projectList,
      };
    },
    [actionEnum.telPhone](
      state: IState,
      action: { type: actionEnum; [extraProps: string]: any },
    ) {
      return {
        ...state,
        phone: action.payload,
      };
    },
    [actionEnum.reset](
      state: IState,
      action: { type: actionEnum; [extraProps: string]: any },
    ) {
      return {
        ...state,
        projectCode: action.payload.projectCode,
        projectName: action.payload.projectName,
      };
    },
  },
};
const useHousekeeperCommerceModel = () => {
  const [state, dispatch] = useReduceWithModel(model);
  // 缓存管家用户信息
  const initalial = (keeperUserInfo: any) =>
    dispatch({ type: actionEnum.initalial, payload: keeperUserInfo });
  const telPhone = (payload: number) =>
    dispatch({ type: actionEnum.telPhone, payload });
  const reset = (projecItem: any) =>
    dispatch({ type: actionEnum.reset, payload: projecItem });
  return {
    state,
    initalial,
    telPhone,
    reset,
  };
};

export default useHousekeeperCommerceModel;
